<template>
    <div :class="{'ly-is-full':isFull}">
        <div class="tableSelect" ref="tableSelect">
            <el-form :inline="true" :model="formInline"  label-position="left">
                <el-form-item label="商品编号：">
                    <el-input size="default" v-model.trim="formInline.cargoNo" maxlength="60" style="width:160px;" clearable placeholder="关键词" @change="search"></el-input>
                </el-form-item>
				<el-form-item label="物流单号：">
				    <el-input size="default" v-model.trim="formInline.inwuliu" maxlength="60" style="width:160px;" clearable placeholder="关键词" @change="search"></el-input>
				</el-form-item>
               <el-form-item label="库存状态：">
				   <div style="width: 150px;">
                    <el-select v-model="formInline.status" placeholder="请选择" clearable @change="search" class="custom-select">
                        <el-option
                                v-for="item in statusList"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
					</div>
                </el-form-item>
                <el-form-item label="创建时间：" v-if="showOtherSearch">
                    <el-date-picker
                            style="width:350px"
                            v-model="timers"
                            type="datetimerange"
                            @change="timeChange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label=""><el-button  @click="search" type="primary" icon="Search" v-show="hasPermission(route.name,'Search')">查询</el-button></el-form-item>
                <el-form-item label=""><el-button  @click="handleEdit('','reset')" icon="Refresh">重置</el-button></el-form-item>
<!--                <el-form-item label=""><el-button  @click="deleteAlllogs" type="danger" v-show="hasPermission(route.name,'goback')">返回上一页</el-button></el-form-item> -->
                <el-form-item label="" @click="clickMore" v-if="!showOtherSearch">
                    <span class="lysearchmore">展开
                        <el-icon><ArrowDown /></el-icon>
                    </span>
                </el-form-item>
                <el-form-item label="" @click="clickMore" v-if="showOtherSearch">
                    <span class="lysearchmore">收起
                        <el-icon><ArrowUp /></el-icon>
                    </span>
                </el-form-item>
            </el-form>
        </div>
        <el-table  :height="tableHeight"  border :data="tableData" ref="tableref" v-loading="loadingPage" style="width: 100%">
            <el-table-column type="index" width="60" align="center" label="序号">
                <template #default="scope">
                    <span v-text="getIndex(scope.$index)"></span>
                </template>
            </el-table-column>
			<el-table-column label="商品图片：" min-width="100">
			    <template #default="scope">
			     <el-image
			        style="width: 60px; height: 60px"
			        :src="scope.row.picUrl"
					:preview-src-list="[scope.row.picUrl]"
					preview-teleported='true'
					@click="handleClick"
					>
			      </el-image> 
				    <el-image-viewer
				      v-if="showViewer"
				      :url-list="scope.row.picUrl"
				      @close="showViewer = false" />
			    </template>
				
			</el-table-column>
			
            <el-table-column min-width="150" prop="cargoNo" label="商品编码" show-overflow-tooltip></el-table-column>
            <el-table-column width="90" prop="value,cargoName" label="商品名称" >
				<template #default="scope">
				        {{scope.row.value}}{{scope.row.cargoName}}
				</template>
				
			</el-table-column>
            <el-table-column width="90" prop="color" label="商品颜色" show-overflow-tooltip></el-table-column>
            <el-table-column width="90" prop="size" label="商品尺寸" show-overflow-tooltip></el-table-column>
			
			<el-table-column width="160" prop="receiver" label="采购员" show-overflow-tooltip></el-table-column>
			<el-table-column width="120"  prop="outqty" label="库存数量" >
				  <template #default="scope">{{ showVaule(scope.row) }}</template>
				
			</el-table-column>
			<el-table-column min-width="160"  prop="price" label="采购单价" >
					    <template #default="scope">{{ FormatMoney(scope.row.price) }}</template>
			</el-table-column> 
			
			<!-- <el-table-column width="160" prop="totalqty" label="统计查询数量" show-overflow-tooltip ></el-table-column> -->

			
            <el-table-column min-width="160" prop="inwuliu" label="入库物流单号" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column min-width="160" prop="clearAmt" label="结算单价" >
           			   <template #default="scope">{{ FormatMoney(scope.row.clearAmt) }}</template>			  
           </el-table-column>-->

			<el-table-column width="100" label="仓位">
			    <template #default="scope">
			        <el-tag v-if="scope.row.currency==='RMB'" type="success">国内</el-tag>
			        <el-tag v-else type="danger">香港</el-tag>
			
			    </template>
			</el-table-column>
			
			
			<el-table-column width="100" label="库存状态">
			    <template #default="scope">
			        <el-tag v-if="scope.row.status===0" type="success">正常入库</el-tag>
			        <el-tag v-else type="danger">退货入库</el-tag>
			
			    </template>
			</el-table-column>

            <el-table-column width="180" prop="created_at" label="创建时间" show-overflow-tooltip>
                <template #default="scope">{{ formatDateTime(scope.row.createTime) }}</template>
            </el-table-column>

        </el-table>
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>

<script setup>
    import {ref,reactive,onMounted,onBeforeUnmount,nextTick} from 'vue'
    import { ElMessage,ElMessageBox } from 'element-plus';
    import {inventoryManage,systemOperationlogDelete,systemOperationlogDeletealllogsDelete} from '@/api/api'
    import Pagination from "@/components/Pagination";
    import {dateFormats,hasPermission,formatDateTime,FormatMoney} from "@/utils/util";
    import useTableHight from '@/mixins/useTableHight';
    import { useRouter,useRoute } from 'vue-router'
	
	import router from '@/router/index.js'
    const route = useRoute()

	let showV=1
	  
    let statusList = ([
		{id:0,name:'非退库存'},
        {id:2,name:'退货查询'},

    ])
    let isFull = ref(false)
    let orderStatic = ref(null)
    let tableSelect = ref(null)
    let tableHeight = useTableHight(orderStatic,tableSelect,isFull.value)
    let loadingPage = ref(false)
    let showOtherSearch = ref(false)//隐藏过长的搜索条件
    let formInline = ref({
        page: 1,
        limit: 10,
    })
    let pageparm = ref({
        page: 1,
        limit: 10,
        total: 0
    })
    let tableData = ref([])

    let timers = ref([])
	let showViewer=false

    function setFull(){
        isFull.value=!isFull.value
        window.dispatchEvent(new Event('resize'))
    }
    // 表格序列号
    function getIndex($index) {
        // (当前页 - 1) * 当前显示数据条数 + 当前行数据的索引 + 1
        return (pageparm.value.page-1)*pageparm.value.limit + $index +1
    }
    const formatBody = (value) => {
        try {
            return JSON.parse(value)
        } catch (err) {
            return value
        }
    }

    function clickMore(){
        showOtherSearch.value = !showOtherSearch.value
        window.dispatchEvent(new Event('resize'))
    }


    function callFather(parm) {
        formInline.value.page = parm.page
        formInline.value.limit = parm.limit
        getData()
    }
    function search() {
		formInline.value.orderId=0
        formInline.value.page = 1
        formInline.value.limit = 10
        getData()
    }
    function timeChange(val){
        if (val) {
            formInline.value.beginAt=dateFormats(val[0],'yyyy-MM-dd hh:mm:ss');
            formInline.value.endAt=dateFormats(val[1],'yyyy-MM-dd hh:mm:ss');
        } else {
            formInline.value.beginAt = null
            formInline.value.endAt = null
        }
        search()
    }
	
	function showVaule(val){

		if(showV==1){
		
			return val.outqty;
		}else{
			
			return val.totalqty;
		}
		
		
	}
    function getData() {
        loadingPage.value = true
		if(formInline.value.status==0 || formInline.value.status==2 ||formInline.value.inwuliu ==''){
			
			showV=1
		}else{
			showV=2
		}
		
		inventoryManage(formInline.value).then(res => {
		    loadingPage.value = false
		    if(res.code ==2000) {
		        tableData.value = res.data.data
		        pageparm.value.page = res.data.page;
		        pageparm.value.limit = res.data.limit;
		        pageparm.value.total = res.data.total;
		    }
		})

    }
	function goback(){
	 	router.go(-1);
	 }
	 
	 // export default {
	 //   setup() {
	 //     const route = useRoute();
	 //     onMounted(() => {
	 //       console.log(route.params.taskId); // 'value1'

	 //     });
	 //   }
	 // }
    onMounted(()=>{

        getData()
    })
</script>

<style scoped>
    .lypopoverbox {
        background: #132738;
        color: #c26a3e;
        height: 560px;
        width: 425px;
        overflow: auto;
    }
    .lypopoverbox::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }
	.custom-select .el-input__placeholder {
	  color: #999; /* 或者其他颜色 */
	}
</style>